import { client } from '@cockpitai/lib/api'
import { TCreateAlertForModulePayload } from './hooks/types'
import { TAlertHistory } from '../notification/types'

export function createAlertForModule(data: TCreateAlertForModulePayload) {
  return client.post(`/alerts`, data)
}

export function getAlerts() {
  return client
    .get<TAlertHistory[]>('/alerts/list/all')
    .then((response) => response.data)
}

export async function deleteAlertForModule(id: any) {
  const response = await client.delete(`/alerts/${id}`)

  return response.data
}
